import React from 'react';
import { MessageCircle } from 'lucide-react';

export function WhatsAppFloat({ phoneNumber }) {
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition-colors duration-300 z-50 flex items-center justify-center"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={45} />
      <span className="ml-2 hidden font-poppins sm:inline">Chat with us</span>
    </a>
  );
}